[
  {
    "type": "DNI",
    "regex": "\\b\\d{8}[A-Z]\\b",
    "context": ["dni", "national"],
    "validate": "dniCheck"
  },
  {
    "type": "INSEE_SSN",
    "regex": "\\b[12]\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}\\s?\\d{3}\\s?\\d{3}\\b",
    "context": ["social security", "insee", "numéro"],
    "validate": "inseeCheck"
  },
  {
    "type": "EU_NATIONAL_ID",
    "regex": "\\b\\d{6}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{3}\\.\\d{2}\\b",
    "context": [
      "eid",
      "rijksregisternummer",
      "national",
      "belgian",
      "netherlands"
    ],
    "validate": "beEidCheck"
  },
  {
    "type": "EIN",
    "regex": "\\b\\d{2}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{7}\\b",
    "context": ["ein", "tax id", "tin", "employer", "federal"],
    "validate": null
  },
  {
    "type": "UK_DL",
    "regex": "\\b[A-Z]{5}\\d{6}[A-Z0-9]{5}\\b",
    "context": ["driving licence", "driver licence", "dvla"],
    "validate": null
  },
  {
    "type": "ON_DL",
    "regex": "\\b[A-Z]\\d{4}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015-]\\d{5}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015-]\\d{5}\\b",
    "context": ["driver licence", "licence", "ontario"],
    "validate": null
  },
  {
    "type": "CA_SIN",
    "regex": "\\b\\d{3}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{3}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{3}\\b",
    "context": ["sin", "social insurance"],
    "validate": null
  },
  {
    "type": "PERSONNUMMER",
    "regex": "\\b\\d{6}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{4}\\b",
    "context": ["personnummer"],
    "validate": "luhn10"
  },
  {
    "type": "NHS_NUMBER",
    "regex": "\\b\\d{3}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{3}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{4}\\b",
    "context": ["nhs number", "chi"],
    "validate": "nhsMod11"
  },
  {
    "type": "MBI",
    "regex": "\\b[0-9][A-HJ-NP-TV-Z][0-9A-HJ-NP-TV-Z][0-9][A-HJ-NP-TV-Z]{2}[0-9][A-HJ-NP-TV-Z]{2}[0-9]{2}\\b",
    "context": ["medicare", "mbi"],
    "validate": null
  },
  {
    "type": "NPI",
    "regex": "\\b\\d{10}\\b",
    "context": ["npi", "provider"],
    "validate": "luhn10"
  },
  {
    "type": "ON_HEALTH",
    "regex": "\\b\\d{10}\\b",
    "context": ["health card", "ohip"],
    "validate": "luhn10"
  },
  {
    "type": "SVNR",
    "regex": "\\b\\d{2}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{6}[\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?[A-Z][\\u002D\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\s-]?\\d{3}\\b",
    "context": ["svnr", "versicherungsnummer"],
    "validate": "svnrMod11"
  }
]
